import React from 'react';
import TrackingContext from './src/components/Context/Tracking';

export const wrapRootElement = ({ element }) => (
  <TrackingContext>{element}</TrackingContext>
);
